module.exports = __webpack_public_path__ + "static/img/IMG_20150307_171357.7eaa9e76.jpg";